export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="lz-gold" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#fff4cf" />
        <stop offset=".55" stopColor="#f1cf7a" />
        <stop offset="1" stopColor="#c9973a" />
      </linearGradient>
      <mask id="lz-cut">
        <rect width="64" height="64" fill="#fff" />
        <circle cx="39.5" cy="26.5" r="15" fill="#000" />
      </mask>
    </defs>
    <circle cx="32" cy="32" r="29" fill="none" stroke="url(#lz-gold)" strokeOpacity=".55" strokeWidth="1" />
    <circle cx="32" cy="32" r="18" fill="url(#lz-gold)" mask="url(#lz-cut)" />
    <path d="M43 19.5 L44.2 23.8 L48.5 25 L44.2 26.2 L43 30.5 L41.8 26.2 L37.5 25 L41.8 23.8Z" fill="url(#lz-gold)" />
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="nav-brand-logo" className="flex items-center gap-2 sm:gap-3 group">
    <span className="transition-transform duration-700 group-hover:rotate-[-10deg]"><LogoMark className="w-8 h-8 md:w-9 md:h-9" /></span>
    <span className="leading-none text-left">
      <span className="block font-display text-sm sm:text-base md:text-lg uppercase tracking-[0.12em] sm:tracking-[0.24em] whitespace-nowrap text-[#f6e7c1]">Lavender Hollow</span>
      <span className="block mt-1 font-mono text-[9px] md:text-[10px] uppercase tracking-[0.18em] sm:tracking-[0.3em] text-purple-200/90 whitespace-nowrap">Handmade bracelets</span>
    </span>
  </button>
);
